import * as yup from 'yup';

/** Standard schema to validate Russian TRRC (Taxpayer Registration Reason Code, rus. "КПП") */
export const russianTrrcSchema = yup
  .string()
  .matches(/^\d{9}$/i, 'КПП контрагента должен состоять из 9 цифр')
